import React from "react";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {Toast, ToastBody, Button,} from 'reactstrap';

import SignatureCanvas from 'react-signature-canvas';

/**
 *  @property {Forms_Completion_Object} state
 *  @property {object} model
 *  @property {Forms_Completion_Properties} model.properties
 *  @property {Forms_Completion_Is} model.is
 *  @property {Forms_Completion_Has} model.has
 */

const setSigPadWidth = () => {
	let scrollbarWidth = 17; //Based on Google Chrome, can detect different browsers if necessary
	let viewportWidth = window.innerWidth - scrollbarWidth;
	const styledPaddingAndPositioning = ((15 + 14 + 40) * 2)
	//15px: .container-fluid | 14px: .MuiCardContent_root |
	//40px: .signature (this is left/right positioning, and includes a second .MuiCardContent_root)

	let breakpointXsmSmCalc = () => viewportWidth - styledPaddingAndPositioning;
	let breakpointMdCalc = () => viewportWidth * 0.7 - styledPaddingAndPositioning;
	let breakpointLgXlgCalc = () => (viewportWidth * 0.7 - 15 * 2 - 14 * 2) * 0.7 - 40 * 2;
	return window.innerWidth < 769 ? breakpointXsmSmCalc()
		: window.innerWidth < 992 ? breakpointMdCalc()
			: breakpointLgXlgCalc();
}

export default class Signature extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Forms_Results._name);
	}

	/** @type Object */
	sigPad1 = null;
	clear = (sigPad) => {
		this[sigPad].clear();
	};

	getSigPad1Ref = (ref) => {
		if (!ref) return;
		this.sigPad1 = ref;
	}

	clearSigPad1Ref = () => this.clear('sigPad1')


	// noinspection JSUnusedLocalSymbols
	handleProcess(event, requestOverride) {
		this.state.signature = this.sigPad1.getCanvas().toDataURL('image/png');
		return true;
	}

	async handleSubmit() {
		this.handleProcess(null, null);
		this.props.afterSave({
			signature: this.state.signature,
		})
	}

	form = () => {
		let sigCanvasDims = {width: setSigPadWidth(), height: 300};
		return (
			<fieldset>
				<h4 className="section-title"> Signature</h4>
				<div>
					<div className={'row signature-row'}>
						<div className={'col-12'}>
							<div className="mdl-typography--text-center">
								<Card>
									<CardContent style={{position: "relative"}}>
										<span className={'signature'}/>
										<SignatureCanvas penColor='black'
										                 canvasProps={Object.assign({className: 'sigCanvas'}, sigCanvasDims)}
										                 ref={this.getSigPad1Ref}/>
									</CardContent>
									<CardActions>
										<Button color="secondary" onClick={this.clearSigPad1Ref}>Clear</Button>
									</CardActions>
								</Card>
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		)
	}
}
